import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";

declare var alertify: any;
@Component({
  templateUrl: "./product.html",
})
export class Product implements OnInit {
  constructor(private router: Router, private http: HttpService) {}

  private data: any = [];

  private imagePath: string = "";

  private page = { pageNumber: 1, pageSize: 10, genreName: "", name: "" };

  ngOnInit(): void {
    this.getPath();
  }

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  private updateProducts(): void {
    let _self = this;
    alertify.confirm(
      "從UPC更新產品",
      "確定要從UPC更新產品嗎？",
      function () {
        _self.http
          .getData(API.product + "/batchUpdateProductsFormUpc")
          .then((res) => {
            if (res.status.code == 0) {
              alertify.success(res.status.message);
              _self.getData();
            } else {
              alertify.error(res.status.message);
            }
          });
      },
      function () {}
    );
  }

  private getData() {
    this.http
      .getData(API.product, {
        pageNumber: this.page.pageNumber - 1,
        pageSize: this.page.pageSize,
        name: this.page.name,
        genreName: this.page.genreName,
      })
      .then((res) => {
        this.data = res.data;
        for (let i = 0; i < this.data.content.length; i++) {
          if (this.data.content[i].image != "") {
            this.data.content[i].image =
              this.imagePath + this.data.content[i].image;
          }
        }
      });
  }

  private editProduct(id: number) {
    this.router.navigate(["index/product", id]);
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/product/Product.component.ts